import { ODataHeader, ODataString, ODataDate } from "pbas-vue-components";

import { translate2 } from "../trans2";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";

const telephoneMask = "(###) ### - ####";
const headers = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.effective_date",
    type: new ODataDate("Current/EffectiveDate"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.address",
    type: new ODataString("Current/Address/City", {
      getString: (item) => {
        var res = "";
        if (item.Current.Address) {
          if (item.Current.Address.SuiteNumber)
            res += item.Current.Address.SuiteNumber;
          if (item.Current.Address.StreetNumber) {
            if (res.length > 0) res += " ";
            res += item.Current.Address.StreetNumber.toString();
          }
          if (item.Current.Address.StreetName) {
            if (res.length > 0) res += ", ";
            res += item.Current.Address.StreetName;
          }
          if (res.length > 0) res += ", ";
          res +=
            item.Current.Address.City +
            ", " +
            item.Current.Address.Province.Code;
          if (item.Current.Address.PostalCode)
            res += " " + item.Current.Address.PostalCode;
        }
        return res;
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
    subHeaders: [
      new ODataHeader({
        title: "globals.address_street_number",
        type: new ODataString("Current/Address/StreetNumber"),
        visible: false,
        allowVisibilityChange: false,
        searchable: true,
      }),
      new ODataHeader({
        title: "globals.address_suite_number",
        type: new ODataString("Current/Address/SuiteNumber"),
        visible: false,
        allowVisibilityChange: false,
        searchable: true,
      }),
      new ODataHeader({
        title: "globals.address_street_name",
        type: new ODataString("Current/Address/StreetName"),
        visible: false,
        allowVisibilityChange: false,
        searchable: true,
      }),
      new ODataHeader({
        title: "globals.address_province",
        type: new ODataString("Current/Address/Province/Code"),
        visible: false,
        allowVisibilityChange: false,
        searchable: true,
      }),
      new ODataHeader({
        title: "globals.address_postal_code",
        type: new ODataString("Current/Address/PostalCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: true,
      }),
    ],
  }),
  new ODataHeader({
    title: "headers.contacts.email",
    type: new ODataString("Current/Email"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.telephone",
    type: new ODataString("Current/PhoneNumber", {
      getString: (item) => {
        if (item.Current.PhoneNumber) {
          return masker(item.Current.PhoneNumber, telephoneMask, true, tokens);
        }
        return "";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.brokers.broker_licensing",
    type: new ODataString("Current/BrokerLicensing"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.brokers.broker_licensing_expiry_date",
    type: new ODataDate("Current/BrokerLicensingExpiryDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.brokers.eo_licensing",
    type: new ODataString("Current/EOLicensing"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.brokers.eo_licensing_expiry_date",
    type: new ODataDate("Current/EOLicensingExpiryDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.brokers.tax_number",
    type: new ODataString("Current/TaxNumber"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Current/BrokerageName"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Current/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.brokers.brokerage_name",
    type: new ODataString("Current/Translations[]/BrokerageName", {
      getString: (item) => translate2(item.Current, "BrokerageName"),
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.organizations",
    type: new ODataString("Organizations[]/Name", {
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          item.Organizations.map((o) => o.Name).join(",") +
          "</div>"
        );
      },
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
];
function getHeaders() {
  return headers;
}
export default getHeaders;
